import type { CharDisplayMode } from '../types'

import { isDisplayMode } from '../display-mode-policy'

export function resolveDisplayModeFromAttribute(
	displayModeAttr: string | null,
): CharDisplayMode | undefined {
	if (!isDisplayMode(displayModeAttr)) {
		return undefined
	}

	return displayModeAttr
}
